























import { Component, Vue } from 'vue-property-decorator'
@Component({})
export default class Menu extends Vue {
  menuList = [
    {
      type: 'el-menu-item',
      icon: 'el-icon-s-cooperation',
      name: 'app可用域名',
      index: '/available-domain'
    },
    {
      type: 'el-menu-item',
      icon: 'el-icon-tickets',
      name: 'app版本列表',
      index: '/app-version'
    }
  ]
  saveMenu(item: any) {
    this.$emit('saveMenu', [{ name: item.name, index: item.index }])
  }
  saveMenuSubs(item: any, itemSubs: any) {
    this.$emit('saveMenu', [
      { name: item.name, index: item.index },
      { name: itemSubs.name, index: itemSubs.index }
    ])
  }
  activeMenu() {
    return this.$route.matched[this.$route.matched.length - 1].path
  }
}
